import { render } from "./ServicePlanning.vue?vue&type=template&id=4e2b7133&scoped=true"
import script from "./ServicePlanning.vue?vue&type=script&lang=js"
export * from "./ServicePlanning.vue?vue&type=script&lang=js"

import "./ServicePlanning.vue?vue&type=style&index=0&id=4e2b7133&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2b7133"]])

export default __exports__